import React, { useEffect, useState } from "react";
import { bp } from "./slug";
import { Link } from "react-router-dom";
import { api } from "./api";
import { Pill } from "./ui";

const label = (s?: string) => (s || "").replace(/_/g, " ").toLowerCase().replace(/^\w/, (c) => c.toUpperCase());

export function RunCard({ runId, pid }: { runId: string; pid: string }) {
  const [run, setRun] = useState<any>(null);
  useEffect(() => {
    let alive = true;
    const tick = () => api(`/jobs/${runId}`).then((r) => { if (!alive) return; setRun(r); if (["QUEUED", "RUNNING"].includes(r.status)) setTimeout(tick, 2500); }).catch(() => undefined);
    tick();
    return () => { alive = false; };
  }, [runId]);
  if (!run) return <div className="runcard skeleton" style={{ height: 56 }} aria-busy="true" />;
  const o = run.outputs || {};
  const wp = o.work_product || {};
  const rev = run.input_digests?.baseline_revision ?? run.versions?.baseline_revision;
  const isPack = run.kind === "assemble_pack";
  const isPlan = run.kind === "prepare_remaining_work";
  return (
    <section className="runcard" data-testid={`run-card-${run.id}`} aria-label={`${run.label} job`}>
      <header><b>{run.label}</b><Pill s={run.status} />{wp.state && <Pill s={wp.state}>{label(wp.state)}</Pill>}
        <span className="tiny muted">{rev != null ? `baseline r${rev}` : ""}{run.generation != null ? ` · gen ${run.generation}` : ""}{isPack && o.pack_draft ? ` · frozen ${o.manifest_digest?.slice(0, 8)}` : ""}</span></header>
      {run.status === "FAILED" && <p className="tiny" style={{ color: "var(--red)" }}>{run.error || "Job failed"}</p>}
      {wp.summary && <p>{wp.summary}</p>}
      {isPack && run.status === "COMPLETED" && <dl className="runfacts">
        <div><dt>Audience</dt><dd>{run.scope?.audience || run.principal?.entity || "programme members"}</dd></div>
        <div><dt>Readiness</dt><dd><Pill s={o.readiness}>{label(o.readiness)}</Pill></dd></div>
        <div><dt>Adverse / open</dt><dd>{o.adverse} / {o.open_items}</dd></div>
        <div><dt>Excludes</dt><dd>outside-audience records, quarantined objects, recovery credentials</dd></div>
      </dl>}
      {isPlan && run.status === "COMPLETED" && Array.isArray(wp.issues) && <ul className="runlist">{wp.issues.slice(0, 4).map((i: any, k: number) => <li key={k}>{i.title || i.summary || JSON.stringify(i).slice(0, 80)}{i.owner ? <small className="muted"> · {i.owner}</small> : null}</li>)}</ul>}
      {run.kind === "assess_change" && run.status === "COMPLETED" && o.classes && <p className="tiny muted">Affected {o.classes.AFFECTED?.length ?? 0} · retained {o.classes.RETAIN?.length ?? 0} · unknown {o.classes.UNKNOWN?.length ?? 0} · operative baseline unchanged</p>}
      <footer>
        <Link to={`${bp(pid)}/desk?run=${run.id}`} className="gull-ctl" data-testid={`run-card-open-${run.id}`}>Open job →</Link>
        {isPack && o.pack_draft && <Link to={`${bp(pid)}/exports`} className="gull-ctl">Pack draft →</Link>}
        {isPlan && <Link to={`${bp(pid)}/remaining`} className="gull-ctl">Open work plan →</Link>}
        <span className="tiny muted">Completion is the job finishing, not approval.</span>
      </footer>
    </section>
  );
}
